import React from 'react';

import { Typography } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

interface RvpBenefitsListProps {
  benefits: readonly string[];
}

export function RvpBenefitsList({ benefits }: RvpBenefitsListProps) {
  return (
    <ul className='m-0 flex list-none flex-col gap-2 p-0'>
      {benefits.map(benefit => (
        <li key={benefit} className='flex items-center gap-2'>
          <Icon.Check size={16} className='shrink-0 text-(--uizz-antd-color-success)' />
          <Typography.Text>{benefit}</Typography.Text>
        </li>
      ))}
    </ul>
  );
}
